import useSWR from 'swr';
function checkForErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText ||
            `useApi | An api call returned HTTP status ${response.status}`);
    }
    return response;
}
const fetcher = (url) => fetch(url)
    .then(checkForErrors)
    .then((res) => res.json());
/**
 * @description
 * A custom hook to make a GET request using the given url using the SWR lib (https://swr.vercel.app/)
 * returns { loading, error, data }
 * @param {String} url - The url to fetch
 * @param {SWRConfiguration} options - The SWR config object - https://swr.vercel.app/docs/options
 * */
export const useApi = (url, options) => {
    const { data, error } = useSWR(url, fetcher, options);
    return {
        data,
        error,
        loading: !error && !data,
    };
};
